import { useRef } from 'react'
import { Link } from 'react-router-dom'
import SectionLabel from './SectionLabel'
import { treks } from '../data/treks'

export default function PopularDestinations() {
  const rowRef = useRef(null)
  const scroll = dir => rowRef.current?.scrollBy({ left: dir * 300, behavior: 'smooth' })

  return (
    <section className="section" style={{ background: 'var(--white)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: '20px', marginBottom: '24px' }}>
        <div>
          <SectionLabel>Where We Go</SectionLabel>
          <h2 className="section-title" style={{ marginBottom: 0 }}>Popular destinations.</h2>
        </div>
        <Link to="/departures" className="btn btn-slate">
          View All Dates
        </Link>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <button className="scroll-arrow" onClick={() => scroll(-1)} aria-label="Previous">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div ref={rowRef} className="scroll-row" style={{ flex: 1 }}>
          {treks.map((t, i) => {
            const hasPhoto = t.image && !String(t.image).startsWith('TODO')
            return (
            <Link
              key={t.id}
              to={`/${t.slug}`}
              className="scroll-row-item"
              style={{
                width: '260px', height: '320px', borderRadius: 'var(--radius-lg)',
                background: 'var(--color-text)',                    // near-black base / photo-less fallback
                backgroundImage: hasPhoto ? `url(${process.env.PUBLIC_URL}${t.image})` : 'none',
                backgroundSize: 'cover', backgroundPosition: 'center',
                position: 'relative', overflow: 'hidden',
                display: 'flex', alignItems: 'flex-end', padding: '20px', color: 'white',
              }}
            >
              {/* bottom scrim for legibility */}
              <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(26,28,27,0.9) 0%, rgba(26,28,27,0.3) 45%, transparent 75%)' }} />
              <span className="data" style={{
                position: 'absolute', top: '16px', left: '20px',
                fontSize: '44px', fontWeight: 700, opacity: 0.5, lineHeight: 1, zIndex: 1,
              }}>
                {String(i + 1).padStart(2, '0')}
              </span>
              <span style={{
                fontFamily: 'var(--font-heading)', fontSize: '19px', fontWeight: 600,
                textTransform: 'uppercase', letterSpacing: '0.5px', position: 'relative', zIndex: 1,
              }}>
                {t.name}
              </span>
            </Link>
            )
          })}
        </div>
        <button className="scroll-arrow" onClick={() => scroll(1)} aria-label="Next">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>
    </section>
  )
}
